module.exports = __webpack_public_path__ + "static/img/af.7773ac25.svg";